module.exports = __webpack_public_path__ + "static/media/tmobile.85e0efee.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/tmobile.png
// module id = 7364
// module chunks = 4